import toastManager from 'utils/ToastManager';

const useAlert = () => {
	const showSuccess = (alert) => {
		toastManager.add({
			type: 'success',
			header: alert?.header ?? 'alert.success',
			message: alert?.message ?? 'alert.operationCompletedSuccessfully',
			...alert
		});
	};

	const showError = (alert) => {
		toastManager.add({
			type: 'error',
			header: alert?.header ?? 'alert.oops',
			message: alert?.message ?? 'alert.anErrorOccurred',
			...alert
		});
	};

	const showInfo = (alert) => {
		toastManager.add({ type: 'info', ...alert });
	};

	const showWarning = (alert) => {
		toastManager.add({ type: 'warning', ...alert });
	};

	const showUpdate = (alert) => {
		toastManager.add({ type: 'update', ...alert });
	};

	return {
		showSuccess,
		showError,
		showInfo,
		showWarning,
		showUpdate
	};
};

export default useAlert;
